import { useEffect, useRef, useState, useMemo, useCallback } from "react";
import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { CssBaseline, ThemeProvider, Box } from "@mui/material";
import darkThemeCustom from "./components/views/visuals/darkThemeCustom";
import lightThemeCustom from "./components/views/visuals/lightThemeCustom";
import { AuthProvider, useAuth } from "./components/auth/AuthContext/AuthContext";
import NavbarSide from "./components/common/NavigationBarSide";
import Navbar from "./components/common/NavigationBar";
import ServiceMessageNotice from "./components/common/ServiceMessageNotice";
import SignIn from "./components/auth/login";
import UserForm from "./components/auth/users/components/UserForm";
import DataGridComponent from "./components/auth/users/components/users";
import LogsList from "./components/views/admin/LogsList";
import OnlineSessions from "./components/views/admin/OnlineSessions";
import BookingRecovery from './components/views/admin/BookingRecovery';
import ActivityBookingsList from "./components/bookings/components/getActivityBookings";
import OperationalDashboard from "./components/bookings/components/OperationalDashboard";
import BookingCalendarBlock from "./components/bookings/components/BookingCalendarBlock";
// Update the path below to match the actual file location


interface NavbarProps {
  toggleDarkMode: () => void;
  darkMode: boolean;
}

const MainLayout: React.FC<NavbarProps> = ({ toggleDarkMode, darkMode }) => {
  const { isAuthenticated, userRole, logout } = useAuth();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100dvh', bgcolor: 'background.default', minWidth: 0 }}>
      <ServiceMessageNotice />
      {<Navbar toggleDarkMode={toggleDarkMode} darkMode={darkMode} />}
      <Box component="main" sx={{
        flexGrow: 1,
        minWidth: 0,
        width: '100%',
        overflowX: 'hidden'
      }}>
        <Routes>
          <Route path="/bookings/recovery" element={isAuthenticated && userRole === '1' ? <BookingRecovery /> : <Navigate to="/login" />} />
          <Route
            path="/list"
            element={
            /*  isAuthenticated &&
                (userRole === "1" ||
                  userRole === "2" ||
                  userRole === "3" ||
                  userRole === "4") ? (
                  */
             isAuthenticated &&  <ActivityBookingsList darkMode={darkMode} />
           /*   ) : (
                <Navigate to="/login" />
              ) */
            }
          />
           <Route path="/OperationalDashboard" element={<OperationalDashboard darkMode={darkMode} rows={[]} />} />
          <Route 
            path="/Agenda" 
            element={
             isAuthenticated && <BookingCalendarBlock 
                onSelectBooking={(booking) => {
                  console.log("Apertura modale per:", booking);
                  // Qui chiamerai la logica per aprire la tua BookingDetailModal
                }}
                darkMode={darkMode}
              />
            } 
          />
          <Route
            path="/users/new"
            element={
              isAuthenticated && userRole === "1" ? (
                <div>
                  <h1>Nuovo Utente</h1>
                  <UserForm twoColumns={false} />
                </div>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/users/list"
            element={
              isAuthenticated && userRole === "1" ? (
                <DataGridComponent />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/logs"
            element={
              isAuthenticated && userRole === "1" ? (
                <LogsList />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/users/online"
            element={
              isAuthenticated && userRole === "1" ? (
                <OnlineSessions />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
        </Routes>
      </Box>
    </Box>
  );
};

const App: React.FC = () => {
  // --- DarkMode ---
  const savedMode = localStorage.getItem("themeMode");

  //const [mode, setMode] = useState<"light" | "dark">(savedMode === "dark" ? "dark" : "light");
  const [mode, setMode] = useState<"light" | "dark">(savedMode === "light" ? "light" : "dark");
  const darkMode = mode === "dark";
  const __setRefreshFunc = useState<Boolean>(false)[1];

  const toggleDarkMode = useCallback(() => {
    setMode((prev) => {
      const newMode = prev === "light" ? "dark" : "light";
      localStorage.setItem("themeMode", newMode);
      return newMode;
    });
  }, []);

  // Memorize theme to avoid recreation on every render
  const theme = useMemo(() => (darkMode ? darkThemeCustom : lightThemeCustom), [darkMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<SignIn />} />
            <Route
              path="*"
              element={
                <MainLayoutWithAuthCheck
                  toggleDarkMode={toggleDarkMode}
                  darkMode={darkMode}
                />
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

// Helper component to handle auth logic for MainLayout
const MainLayoutWithAuthCheck: React.FC<NavbarProps> = ({ toggleDarkMode, darkMode }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <MainLayout toggleDarkMode={toggleDarkMode} darkMode={darkMode} />;
};

export default App;
